'use client';

import { MfeReactComponent } from '@carvana/microfrontend-react';
import { COMPOSER_MODULE } from '~/constants/common/MfeModules';
import useMfeMountGate from '~/hooks/common/mfe/useMfeMountGate';
import useLoadComposerUiMfe from './useLoadComposerUiMfe';

export default function ComposerUiMfe() {
  const canMount = useMfeMountGate(COMPOSER_MODULE);

  useLoadComposerUiMfe();

  if (!canMount) return null;

  return <MfeReactComponent component="default" module={COMPOSER_MODULE} />;
}
